<template>
  <div class="v-table">
    <table :class="['v-table__table']">
      <thead>
        <tr class="v-row">
          <th class="v-th" v-for="(col, index) in columns" :key="index">
            <v-text font-size="2" class="text-uppercase text-gray-dark py-1 px-3">{{col}}</v-text>
          </th>
        </tr>
      </thead>
      <tbody>
        <slot></slot>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-table {
  overflow-x: auto;

  &__table {
    width: 100%;
    border-collapse: collapse;
  }

  thead {
    text-align: left;
  }
}
</style>
